<div class="col-lg-12 parent" *ngIf="reportData.length > 0">
  <div class="row child">
    <p-card class="card-spacing-0">
      <span
        class="d-flex justify-content-between align-items-center m-3 globalborder-btm-header pb-2">
        <span class="col-auto">
          <h2 class="mb-0">Top Clients</h2>
        </span>
        <span class="d-flex gap-2 customizefilter-btn">
          <p-button
            label="Export Excel"
            variant="outlined"
            icon="pi pi-cloud-upload"
            severity="secondary"
            (click)="exportExcel()"
            class="fullwdth secondary-btn" />
        </span>
      </span>

      <div class="col-12">
        <p-table
          #dt
          [value]="reportData"
          styleClass="p-datatable-customers ordersListing search-more"
          [rowHover]="true"
          [rows]="50"
          [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10, 20, 50, 250, 1000]"
          [paginator]="true"
          [filterDelay]="0"
          (onFilter)="onFilter($event, dt)"
          (onPage)="setMyPagination(dt)"
          selectionMode="multiple"
          sortMode="multiple"
          stripedRows
          [rowHover]="true"
          [rows]="20"
          [showCurrentPageReport]="true"
          scrollHeight="calc(100vh - 430px)"
          [size]="'small'"
          [paginator]="true"
          paginatorStyleClass="paginator-table"
          styleClass="table-listing"
          (onSort)="onSortEvent($event)">
          <ng-template pTemplate="header">
            <tr class="table-head">
              <th class="number" pSortableColumn="ClientName">
                Client Name <p-sortIcon field="ClientName"></p-sortIcon>
              </th>
              <th class="status" pSortableColumn="ClientAccount">
                Client Acct
                <p-sortIcon field="ClientAccount"></p-sortIcon>
              </th>
              <th class="currency" pSortableColumn="MonthWiseSell">
                {{ getDateRangeString() }} Sell
                <p-sortIcon field="MonthWiseSell"></p-sortIcon>
              </th>
              <th class="gp" pSortableColumn="GPPercent">
                GP %
                <p-sortIcon field="GPPercent"></p-sortIcon>
              </th>
              <th class="curreny" pSortableColumn="MonthWiseGP">
                {{ getDateRangeString() }} GP
                <p-sortIcon field="MonthWiseGP"></p-sortIcon>
              </th>
              <th></th>
              <ng-container *ngFor="let header of headers">
                <th colspan="2" style="text-align: center">{{ header }}</th>
              </ng-container>
            </tr>
            <tr class="customstickyheaderfilter">
              <th style="width: 3rem">
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="ClientName"
                    id="ClientName"
                    [(ngModel)]="clientName"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'ClientName',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter" />
                </div>
              </th>
              <th>
                <div class="d-flex">
                  <input
                    pInputText
                    jniAutoCompleteBlocker
                    pInputText
                    type="text"
                    name="ClientAccount"
                    id="ClientAccount"
                    [(ngModel)]="clientAcct"
                    (input)="
                      dt.filter(
                        $any($event.target).value,
                        'ClientAccount',
                        'contains'
                      )
                    "
                    placeholder=""
                    class="p-column-filter" />
                </div>
              </th>
              <th></th>
              <th></th>
              <th></th>
              <th></th>
              <!-- Dynamic subheaders -->
              <ng-container *ngFor="let header of headers">
                <th class="text-center">Sell</th>
                <th class="text-center">GP</th>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
            <tr
              class="p-selectable-row"
              [pSelectableRow]="rowData"
              [pSelectableRowIndex]="rowIndex">
              <td>{{ rowData.ClientName }}</td>
              <td>
                <a
                  class="link"
                  (click)="openClientSummaryModal(rowData?.ClientAccount)"
                  >{{ rowData.ClientAccount }}</a
                >
              </td>
              <td class="currency text-right">
                <a
                  class="link"
                  (click)="
                    openOrderBilledInvoiceReportModal(rowData?.ClientAccount)
                  "
                  >{{
                    rowData.MonthWiseSell | currency: "USD" : "symbol" : "1.2-2"
                  }}</a
                >
              </td>
              <td class="gp">{{ rowData.GPPercent | number: "1.2-2" }}</td>
              <td class="currency text-right">
                {{ rowData.MonthWiseGP | currency: "USD" : "symbol" : "1.2-2" }}
              </td>
              <td>
                <p-chart
                  type="bar"
                  width="80"
                  height="30"
                  [data]="{
                    labels: [''],
                    datasets: [
                      {
                        label: '',
                        backgroundColor: '#42A5F5',
                        data: [rowData.MonthWiseGP, maxGpValue],
                      },
                    ],
                  }"
                  [options]="{
                    indexAxis: 'y',
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                    scales: {
                      x: {
                        ticks: {
                          color: '#495057',
                        },
                        grid: {
                          color: '#ebedef',
                        },
                        display: false,
                      },
                    },
                  }"></p-chart>
              </td>
              <ng-container *ngFor="let data of rowData?.Data">
                <td class="text-right">
                  <a
                    class="link"
                    (click)="
                      openOrderBilledInvoiceReportModalWithSpecificMonth(
                        rowData?.ClientAccount,
                        data
                      )
                    "
                    >{{ data.Sell | currency: "USD" : "symbol" : "1.2-2" }}</a
                  >
                </td>
                <td class="text-right">
                  {{ data.GP | currency: "USD" : "symbol" : "1.2-2" }}
                </td>
              </ng-container>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="20">No record found.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </p-card>
  </div>
</div>

<jni-modal-stacker
  *ngIf="showClientSummaryDialog"
  [displayModal]="showClientSummaryDialog">
  <div class="panelBody">
    <jni-client-details
      [clientIdFromModal]="clientAccount"
      [isModal]="true"
      (closeEvent)="closeClientSummaryModal()">
    </jni-client-details>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="showOrderBilledInvoiceReportDialog"
  [displayModal]="showOrderBilledInvoiceReportDialog"
  (closeEvent)="closeOrderBilledInvoiceReportModal()">
  <div class="panelBody">
    <jni-order-billed-invoiced-details
      [ordersInvoicedDetailsRequest]="ordersInvoicedDetailsRequest"
      [showTotalSell]="false"
      (closeModalEvent)="closeOrderBilledInvoiceReportModal()"
      [isModal]="true">
    </jni-order-billed-invoiced-details>
  </div>
</jni-modal-stacker>
